import React from "react";
import { maskText } from "../utils/mask";
const mask = (raw) => `${raw.substr(0, raw.length - 4)}xxxx`;
export default (props) => {
    const address = props.getAddress();
    const allowPersonalNumberEdit = !props.useBankId;
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { className: "page-section page-section-border" },
            React.createElement("div", { "data-ecom-columnrow": "", className: "font-size-small m-b-half" },
                React.createElement("div", { className: "column" },
                    React.createElement("div", { className: "font-medium" }, "Personnummer")),
                allowPersonalNumberEdit && (React.createElement("div", { className: "column" },
                    React.createElement("button", { "data-ecom-link": "font-inerit", onClick: props.onShowCustomerInformationInitial }, "\u00C4ndra")))),
            React.createElement("div", { className: "m-t-half" },
                React.createElement("i", { className: "icon-profile m-r-half" }),
                mask(props.data.customer.personalNumber))),
        React.createElement("section", { className: "page-section page-section-border" },
            React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
                React.createElement("div", { className: "column" },
                    React.createElement("div", { className: "font-medium font-size-small" }, "F\u00F6rnamn")),
                React.createElement("div", { className: "column" }, maskText(address.givenName))),
            React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
                React.createElement("div", { className: "column" },
                    React.createElement("div", { className: "font-medium font-size-small" }, "Efternamn")),
                React.createElement("div", { className: "column" }, maskText(address.surname))),
            React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
                React.createElement("div", { className: "column" },
                    React.createElement("div", { className: "font-medium font-size-small" }, "Gatuadress")),
                React.createElement("div", { className: "column" }, address.street)),
            React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
                React.createElement("div", { className: "column" },
                    React.createElement("div", { className: "font-medium font-size-small" }, "Postnummer")),
                React.createElement("div", { className: "column" }, address.postalCode)),
            React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
                React.createElement("div", { className: "column" },
                    React.createElement("div", { className: "font-medium font-size-small" }, "Postort")),
                React.createElement("div", { className: "column" }, address.city)))));
};
